import React from 'react'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { MineturPricesService } from '../../../../services/prices-fuel-stations/pricesFuelStations.service'
import useAccess from '../../../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../../../utils/constants/roles'
import useModal from '../../../../utils/hooks/useModal'
import Modal from '../../../../components/modal/Modal'
import ChangePriceForm from '../../../../components/fuel-stations/fuel-prices/ChangePriceForm'
import useHandlerBasicActions from '../../../../utils/hooks/useHandlerBasicActions'
import MainCommonView from '../../../../components/common/MainCommonView'
import PriceHistoryDataTable from '../../../../components/fuel-stations/fuel-prices/PriceHistoryDataTable'
import './ownFuelStationPrices.scss'

const OwnFuelStationPrices = () => {
  const { id } = useParams()
  const { formatMessage: msg } = useIntl()

  const { isShowing, toggle } = useModal()
  const { canAdd } = useAccess()

  const getAllById = async ({ filter, limit, skip, sort }) =>
    MineturPricesService.getCenterPrice({ id, filter, sort, limit, skip })

  const dataFacade = useHandlerBasicActions({
    getAll: getAllById,
    sortFieldInitial: 'createdAt',
    sortInit: -1,
  })

  const handleSubmit = () => {
    dataFacade.reload()
    toggle()
  }

  const headerOptions = {
    title: msg({ id: 'price.history' }),
    handlerHeaderActions: {
      showBackButton: true,
      secondaryButton: canAdd(MODULES.FUELSTATIONS, GROUPS.PRICES) && toggle,
      secondaryButtonText: 'button.change.prices',
      secondaryButtonIcon: 'pi-euro',
    },
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <PriceHistoryDataTable
      prices={dataFacade?.data?.resp}
      sortOptions={dataFacade?.sortOptions}
    />
  )

  return (
    <div className="own-prices">
      <MainCommonView
        headerOptions={headerOptions}
        componentData={dataTable}
        pagerOptions={pagerOptions}
      />

      <Modal
        isShowing={isShowing}
        hide={toggle}
        width="90%"
        maxWidth="950px"
        title={msg({ id: 'fuels.price.change' })}
        context={
          <ChangePriceForm handleSubmit={handleSubmit} ownStationId={id} />
        }
      />
    </div>
  )
}

export default OwnFuelStationPrices
